export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_TO_CART = "REMOVE_TO_CART";
export const CLEAR_TO_CART = "CLEAR_TO_CART";
export const OVERLAP_TO_CART = "OVERLAP_TO_CART";
export const ADMIN_PACKAGE_CURRENT_MAIN_INDEX = "ADMIN_PACKAGE_CURRENT_MAIN_INDEX";
export const ADMIN_PACKAGE_CURRENT_CHILD_INDEX = "ADMIN_PACKAGE_CURRENT_CHILD_INDEX";
export const ADD_ADMIN_PACKAGE_MAIN_ITEM = "ADD_ADMIN_PACKAGE_MAIN_ITEM";
export const UPDATE_ADMIN_PACKAGE_MAIN_ITEM = "UPDATE_ADMIN_PACKAGE_MAIN_ITEM";
export const REMOVE_ADMIN_PACKAGE_MAIN_ITEM = "REMOVE_ADMIN_PACKAGE_MAIN_ITEM";
export const ADD_ADMIN_PACKAGE_CHILD_ITEM = "ADD_ADMIN_PACKAGE_CHILD_ITEM";
export const UPDATE_ADMIN_PACKAGE_CHILD_ITEM = "UPDATE_ADMIN_PACKAGE_CHILD_ITEM";
export const REMOVE_ADMIN_PACKAGE_CHILD_ITEM = "REMOVE_ADMIN_PACKAGE_CHILD_ITEM";
export const CLEAR_ADMIN_PACKAGE_CART = "CLEAR_ADMIN_PACKAGE_CART";
export const SET_ADMIN_PACKAGE_CART = "SET_ADMIN_PACKAGE_CART";

export const SET_CUSTOMER_PACKAGE_CART = "SET_CUSTOMER_PACKAGE_CART";
export const UPDATE_CUSTOMER_PACKAGE_CHILD_SELECT_ITEM = "UPDATE_CUSTOMER_PACKAGE_CHILD_SELECT_ITEM";
export const SET_CUSTOMER_DISCOUNT_PERCENTAGE = "SET_CUSTOMER_DISCOUNT_PERCENTAGE";

export const MAKE_PACKAGE_BUILD_URL = "MAKE_PACKAGE_BUILD_URL";
export const PLAN_SHUFFLE_UPDATE_URL = "PLAN_SHUFFLE_UPDATE_URL";
export const ZONE_LIST_ACCOMMODATION_DATA_MASTER = "ZONE_LIST_ACCOMMODATION_DATA_MASTER";